import React from 'react'
import classNames from 'classnames/bind'
import { Head } from '@inertiajs/react'
import { router } from '@inertiajs/react'
import AdminLayout from '@/admin/shell/layouts/AdminLayout'
import DataTable from '@/admin/shared/components/DataTable/DataTable'
import { TableSearch } from '@/admin/shared/components/DataTable/Toolbar'
import { COLUMNS, renderSessionActions } from '../components/AnalyticsTable'
import type { AnalyticsPageProps } from '../types'
import styles from '../analytics.module.scss'

const cx = classNames.bind(styles)

function AnalyticsPage({ sessions, search, filter, from, to, exclude_bots, exclude_admin }: AnalyticsPageProps) {
  const navigate = (params: Record<string, string | number | boolean | undefined>) =>
    router.get('/admin/analytics', params as Record<string, string>, { preserveState: true, replace: true })

  return (
    <>
      <Head title="Admin — Analytics" />
      <DataTable
        columns={COLUMNS}
        rows={sessions.data}
        total={sessions.total}
        page={sessions.current_page}
        perPage={sessions.per_page}
        lastPage={sessions.last_page}
        toolbarLeft={
          <>
            <TableSearch
              value={search}
              placeholder="Search by session ID, anon ID, or IP…"
              onChange={q => navigate({ search: q || undefined, page: 1, filter, from, to, exclude_bots, exclude_admin })}
            />
            <select
              className={cx('filterSelect')}
              value={filter ?? ''}
              onChange={e => navigate({ filter: e.target.value || undefined, page: 1, search, from, to, exclude_bots, exclude_admin })}
            >
              <option value="">All traffic</option>
              <option value="humans">Humans</option>
              <option value="bots">Bots</option>
            </select>
            <label className={cx('botToggle')}>
              <input
                type="checkbox"
                checked={!!exclude_bots}
                onChange={e => navigate({ exclude_bots: e.target.checked || undefined, page: 1, search, filter, from, to, exclude_admin })}
              />
              Exclude bots
            </label>
            <label className={cx('botToggle')}>
              <input
                type="checkbox"
                checked={exclude_admin !== false}
                onChange={e => navigate({ exclude_admin: e.target.checked ? 1 : 0, page: 1, search, filter, from, to, exclude_bots })}
              />
              Exclude admin
            </label>
            <input
              type="date"
              className={cx('dateInput')}
              value={from ?? ''}
              onChange={e => navigate({ from: e.target.value || undefined, page: 1, search, filter, to, exclude_bots, exclude_admin })}
            />
            <input
              type="date"
              className={cx('dateInput')}
              value={to ?? ''}
              onChange={e => navigate({ to: e.target.value || undefined, page: 1, search, filter, from, exclude_bots, exclude_admin })}
            />
          </>
        }
        onPageChange={p => navigate({ search, page: p, filter, from, to, exclude_bots, exclude_admin })}
        onPerPageChange={n => navigate({ search, per_page: n, page: 1, filter, from, to, exclude_bots, exclude_admin })}
        emptyMessage="No analytics sessions found."
        selectable={false}
        actions={renderSessionActions}
      />
    </>
  )
}

AnalyticsPage.layout = (page: React.ReactNode) => (
  <AdminLayout title="Analytics">{page}</AdminLayout>
)

export default AnalyticsPage
